<script setup lang="ts">
/* Components */
import DeliveryPoints from '@/components/Delivery/DeliveryPoints.vue'
import DeliveryMap from '@/components/Delivery/DeliveryMap.vue'

defineProps({
  currentView: {
    type: Number,
    required: true,
  },
})

const { isDesktop } = useDevice()

// Выбранная точка из списка
const selectedPointId = ref<number | null>(null)

const scrollToField = (scrollField: string) => {
  document
    .querySelector<HTMLElement>(`#${scrollField}`)
    ?.scrollIntoView({ behavior: 'smooth', block: 'nearest' })
}

const setSelectPoint = (pointId: number | null) => {
  selectedPointId.value = pointId || null

  if (pointId) scrollToField(`point-${pointId}`)
}
</script>

<template>
  <section class="section">
    <delivery-points
      v-show="isDesktop || currentView"
      :selected-point-id="selectedPointId"
      class="section__points"
      @set-select-point="setSelectPoint"
    />

    <delivery-map
      v-show="isDesktop || !currentView"
      class="section__map"
      @set-select-point="setSelectPoint"
    />
  </section>
</template>

<style lang="scss" scoped>
.section {
  position: relative;
  display: grid;
  grid-template-columns: 1fr 2fr;
  height: 750px;
  overflow: hidden;
  border: 1px solid $scrollbar;
  border-radius: 10px;

  &__points {
    border-right: 1px solid $carousel-dot-background;
  }

  @include media('<desktop-mini') {
    grid-template-columns: 1fr;
    height: inherit;
    margin: 0 -20px;
    border: none;
    border-radius: 0;

    &__map {
      height: 500px;
    }

    &__points {
      max-height: 500px;
    }
  }
}
</style>
